import { request } from './client';
import type { WhalesFilters, WhalesReport } from './types';

// Every agent key may read it. Empty days are not sent.
export const fetchWhales = (key: string, filters: WhalesFilters, signal?: AbortSignal) => {
  const params = new URLSearchParams({ cohort: filters.cohort, limit: String(filters.limit) });
  if (filters.from) params.set('from', filters.from);
  if (filters.to) params.set('to', filters.to);
  return request<WhalesReport>(`/api/whales?${params.toString()}`, { key, signal });
};
